// EDIT BY ALI FOR DARK MODE - Added useTheme import
import {Box, Card, CardContent, Divider, Typography, useTheme} from "@mui/material";
import React from "react";


const CompanyDetailSection = props => {
  // EDIT BY ALI FOR DARK MODE - Added useTheme hook
  const theme = useTheme();
  const {
    title,
    children,
    padding
  } = props

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        padding: padding,
        minWidth: "545px"
      }}
    >
      {/* EDIT BY ALI FOR DARK MODE - Updated Card to use theme colors */}
      <Card
        variant={"outlined"}
        sx={{
          minWidth: "545px",
          border: '0px solid white',
          backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : undefined,
        }}
      >
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ color: theme.palette.mode === "dark" ? "#FFFFFF" : undefined }}>
              {title}
          </Typography>
          {/* EDIT BY ALI FOR DARK MODE - Updated Divider to use theme colors */}
          <Divider sx={{
            marginTop: "16px", 
            marginBottom: "16px",
            borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : undefined,
          }}/>
            {children}
        </CardContent>
      </Card>
    </Box>
  )
}


export default CompanyDetailSection